import { ewent } from "../../../lib/reactive";
import { CaptureInterval } from "../../../lib/alt1/capture";
import Behaviour from "../../../lib/ui/Behaviour";
import { Alt1 } from "../../../lib/alt1/Alt1";
import { Alt1Overlay } from "../../../lib/alt1/overlay/Alt1Overlay";
export class AbstractPuzzleProcess extends Behaviour {
    constructor() {
        super();
        this.puzzle_closed = ewent();
        this.solution_overlay = this.withSub(new Alt1Overlay());
    }
    begin() {
        this.start_time = Date.now();
        this.lifetime_manager.bind(this.token = Alt1.instance().capturing.subscribe({
            options: (time) => ({ interval: CaptureInterval.fromApproximateInterval(20), area: this.area() }),
            handle: async (value) => {
                try {
                    this.tick(value.value);
                }
                catch (e) {
                    console.error(e.toString());
                }
            },
            paused: () => this.capturingPaused()
        }));
    }
    capturingPaused() {
        return false;
    }
    end() {
    }
    puzzleClosed() {
        this.stop();
        this.puzzle_closed.trigger(this);
    }
}
